module.exports = __webpack_public_path__ + "img/efirma.e33f73cf.png";